import { render } from "./PurchaseOrderList copy.vue?vue&type=template&id=76add344&scoped=true"
import script from "./PurchaseOrderList copy.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderList copy.vue?vue&type=script&lang=js"

import "./PurchaseOrderList copy.vue?vue&type=style&index=0&id=76add344&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76add344"]])

export default __exports__